import {Component} from "@angular/core";
import {smoothlyMenu} from "../../../app.helpers";
import {Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {User} from "../../../models/user.model";
import {HelperService} from "../../../services/helperService";
declare let $: any;

@Component({
	selector: "tig-topnavbar",
	templateUrl: "topnavbar.template.html"
})
export class TopNavbarComponent
{


	/**
	 * Attributes
	 */
	OBJ_current_user: User;
	OBJ_client: {id: number, name: string, logo: string};


	/**
	 * Function > constructor
	 * @param {Router} OBJ_router
	 * @param {TranslateService} OBJ_translate_service
	 * @param {HelperService} OBJ_helper_service
	 */
	constructor
	(
		private OBJ_router: Router,
		public OBJ_translate_service: TranslateService,
		private OBJ_helper_service: HelperService
	)
	{

		// get client id and current user from local storage
		this.OBJ_current_user = this.OBJ_helper_service.getFromLocalstorage('current_user');
		this.OBJ_client = OBJ_helper_service.getFromLocalstorage('client');

	} // end function constructor


	/**
	 * Function > toggleNavigation
	 */
	toggleNavigation(): void
	{
		$("body").toggleClass("mini-navbar");
		smoothlyMenu();
	} // end function toggleNavigation


	/**
	 * Function > activeRoute
	 * @param {string} STR_routename
	 * @returns {boolean}
	 */
	activeRoute(STR_routename: string): boolean
	{
		return this.OBJ_router.url.indexOf(STR_routename) > -1;
	} // end function activeRoute


	/**
	 * Function > openExternalUrl
	 * @param {string} STR_url
	 * @param {string} STR_target
	 */
	openExternalUrl(STR_url: string, STR_target: string='_blank'): void
	{
		window.open(STR_url, STR_target);
	} // end function openExternalUrl


} // end class TopNavbarComponent
